import { render } from "./AuthNavigation.vue?vue&type=template&id=4f044d2e&scoped=true&ts=true"
import script from "./AuthNavigation.vue?vue&type=script&lang=ts"
export * from "./AuthNavigation.vue?vue&type=script&lang=ts"

import "./AuthNavigation.vue?vue&type=style&index=0&id=4f044d2e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f044d2e"]])

export default __exports__